import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import PropTypes from 'prop-types';

import FoundationTestKeys from '../../../FoundationTestKeys';
import { LightThemeColors } from '../../Themes';
import VFText from '../../VFText';

import styles from './Title.Styles';

function Title({ theme, step, index, activeIndex, onStepPress }) {
  return (
    <TouchableWithoutFeedback
      onPress={() => onStepPress(index)}
      testID={FoundationTestKeys.horizontalStepperTitleTO}
    >
      <View
        style={styles.titleContainerStyle}
        testID={FoundationTestKeys.horizontalStepperTitleView}
      >
        <VFText
          style={[
            styles.titleStyle,
            index < activeIndex
              ? styles.finishedTitleTextStyle(theme)
              : index === activeIndex
              ? styles.activeTitleTextStyle(theme)
              : styles.notInitiatedTitleTextStyle(theme),
          ]}
          {...step}
          testKey={FoundationTestKeys.horizontalStepperTitleText}
        />
      </View>
    </TouchableWithoutFeedback>
  );
}

Title.defaultProps = {
  theme: LightThemeColors,
  onStepPress: () => {},
};

Title.propTypes = {
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  index: PropTypes.number,
  activeIndex: PropTypes.number,
  step: PropTypes.shape({
    i18nKey: PropTypes.string.isRequired,
    accessibilityLabel: PropTypes.string,
  }),
  onStepPress: PropTypes.func,
};

export default Title;
